import { Component, AfterViewInit, ViewChild, ElementRef, Renderer2, Input } from '@angular/core';
import { FunctionService } from 'src/app/services/function.service';
import { to64decode } from 'src/app/helpers/base64';
import { PersonasService } from 'src/app/services/personas/personas.service';
import { parse } from 'circular-json';
import { apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
import { PrecificacaoService } from 'src/app/services/precificacao/precificacao.service';
import { WorkflowService } from 'src/app/services/workflow/workflow.service';

@Component({
  selector: 'app-precificacao',
  templateUrl: './precificacao.component.html',
  styleUrls: ['./precificacao.component.scss']
})
export class PrecificacaoComponent implements AfterViewInit {
  @ViewChild('container', { static: false }) containerRef!: ElementRef;
  @Input() service: string = ''

  private mfeElement: HTMLElement | null = null;
  personas: any[] = []
  isLoading: boolean = false;
  pricing_uuids: any[] = []
  logs_uuids: any[] = []
  workflow: any

  constructor(
    private renderer: Renderer2,
    private personasService: PersonasService,
    private functionService: FunctionService,
    private precificacaoService: PrecificacaoService,
    private workflowService: WorkflowService,
  ) { }

  async ngOnInit() {
    await this.getPersonasTree()
  }

  async ngAfterViewInit() {
    await this.getPersonasTree()
    await this.getArrayTableUuid()
    await this.getLogsUuid()
    await this.getWorkflow()

    const container: HTMLElement = this.containerRef.nativeElement;
    const body: any = {
      'corporation': {
        'name': to64decode(localStorage.getItem('corporation')).name,
        'uuid': to64decode(localStorage.getItem('corporation')).uuid
      },
      'environment': {
        'name': to64decode(localStorage.getItem('environment')).name,
        'uuid': to64decode(localStorage.getItem('environment')).uuid
      },
      'user': {
        'name': to64decode(localStorage.getItem('me')).name,
        'uuid': to64decode(localStorage.getItem('me')).uuid,
        'email': to64decode(localStorage.getItem('me')).email,
        'is_admin_master': to64decode(localStorage.getItem('me'))?.is_admin_master ?? false,
        'profile': {
          'uuid': to64decode(localStorage.getItem('profile'))?.uuid ?? '',
          'name': to64decode(localStorage.getItem('profile'))?.name ?? '',
          'permissions': to64decode(localStorage.getItem('profile'))?.permissions ?? '',
          'type': to64decode(localStorage.getItem('profile'))?.type ?? '',
        },
        'is_approval': to64decode(localStorage.getItem('user_corporation'))?.is_approval ?? false,
      },
      'personas': this.personas,
      'workflow': this.workflow,
      'pricing_uuids': this.pricing_uuids,
      'logs_uuids': this.logs_uuids
    };


    if (this.service == '/precificacao/tabela') {
      const tableElement = this.renderer.createElement('table-component');
      this.renderer.appendChild(container, tableElement);

      this.renderer.setProperty(tableElement, 'data', body);
      // console.log('Array de dados passado para o TableComponent:', body);
    } else if (this.service == '/precificacao/planilhas') {
      const spreadsheetElement = this.renderer.createElement('spreadsheets-component');
      this.renderer.appendChild(container, spreadsheetElement);

      this.renderer.setProperty(spreadsheetElement, 'data', body);
      // console.log('Array de dados passado para o SpreadsheetsComponent:', body);
    } else if (this.service == '/precificacao/parametros') {
      const parametersElement = this.renderer.createElement('parameters-component');
      this.renderer.appendChild(container, parametersElement);

      this.renderer.setProperty(parametersElement, 'data', body);
      // console.log('Array de dados passado para o ParametersComponent:', body);
    }

    window.addEventListener('saveBaseOnepagePrecificacao', this.saveBaseOnepagePrecificacao.bind(this) as unknown as EventListener);
    window.addEventListener('closeMfe', this.closeMfe.bind(this) as unknown as EventListener);
    window.addEventListener('setTableUuid', this.setTableUuid.bind(this) as unknown as EventListener);
    window.addEventListener('setLogsUuid', this.setLogsUuid.bind(this) as unknown as EventListener);
  }

  ngOnDestroy() {
    window.removeEventListener('saveBaseOnepagePrecificacao', this.saveBaseOnepagePrecificacao.bind(this) as unknown as EventListener);
    window.removeEventListener('closeMfe', this.closeMfe.bind(this) as unknown as EventListener);
    window.removeEventListener('setTableUuid', this.setTableUuid.bind(this) as unknown as EventListener);
    window.removeEventListener('setLogsUuid', this.setLogsUuid.bind(this) as unknown as EventListener);
  }

  closeMfe() {
    this.functionService.triggerCloseService();
  }

  async getWorkflow() {
    try {
      const response: any = await this.workflowService.getWorkflow({
        'corporation': {
          'name': to64decode(localStorage.getItem('corporation')).name,
          'uuid': to64decode(localStorage.getItem('corporation')).uuid
        },
        'environment': {
          'name': to64decode(localStorage.getItem('environment')).name,
          'uuid': to64decode(localStorage.getItem('environment')).uuid
        },
      }).toPromise();
      
      if (response && response.data) {

        this.workflow = parse(parse(response.data).json);

        this.workflow = getParents(this.workflow, to64decode(localStorage.getItem('me')).email)
      } else {
        throw new Error('Erro ao consultar workflow!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error);
    }
  }

  async findPersonasNodes(nodes: any[], result: any[] = []): Promise<any[]> {
    for (const node of nodes) {

      if (node.data.type === 'persona') {
        result.push({ label: node.label, uuid: node.uuid, value: node.data?.cost_min });
      }

      if (node.children && node.children.length > 0) {
        await this.findPersonasNodes(node.children, result);
      }
    }

    return result;
  }

  async getPersonasTree() {
    try {
      const response: any = await this.personasService.getPersonasForPrecificacao({
        'corporation': {
          'name': to64decode(localStorage.getItem('corporation')).name,
          'uuid': to64decode(localStorage.getItem('corporation')).uuid
        },
        'environment': {
          'name': to64decode(localStorage.getItem('environment')).name,
          'uuid': to64decode(localStorage.getItem('environment')).uuid
        },
      }).toPromise();
      if (response && response.data) {
        this.personas = response.data
      } else {
        throw new Error('Erro ao consultar àrvore de personas!\nConsulte o administrador do sistema!');
      }
    }
    catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async saveBaseOnepagePrecificacao(event?: CustomEvent) {
    if (event) {
      // console.log('Função chamada pelo componente MFe com dados:', event.detail);
    } else {
      // console.log('Função chamada pelo componente MFe');
    }
  }

  async getArrayTableUuid() {
    try {
      const response: any = await this.precificacaoService.getArrayTableUuid({
        'corporation_uuid': to64decode(localStorage.getItem('corporation')).uuid,
      }).toPromise();
      if (response && response.data) {
        this.pricing_uuids = response.data
      } else {
        throw new Error('Erro ao consultar àrvore de personas!\nConsulte o administrador do sistema!');
      }
    }
    catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async setTableUuid(event?: CustomEvent) {
    try {
      const response: any = await this.precificacaoService.setTableUuid({
        'organization_uuid': to64decode(localStorage.getItem('corporation')).uuid,
        'pricing_uuid': event ? event?.detail : '',
      })
    }
    catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async getLogsUuid() {
    try {
      const response: any = await this.precificacaoService.getLogsUuid({
        'corporation_uuid': to64decode(localStorage.getItem('corporation')).uuid,
      }).toPromise();

      if (response && response.data) {
        this.logs_uuids = response.data
      } else {
        throw new Error('Erro ao consultar àrvore de personas!\nConsulte o administrador do sistema!');
      }
    }
    catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async setLogsUuid(event?: CustomEvent) {
    try {
      const response: any = await this.precificacaoService.setLogUuid({
        'organization_uuid': to64decode(localStorage.getItem('corporation')).uuid,
        'pricing_taxes_parameter_uuid': event ? event?.detail : '',
      })
    }
    catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

}

function getParents(
  roots: any[],
  targetEmail: string
): { status: string; parentsArray: { label: string; email: string }[] } {
  const parents: { label: string; email: string }[] = [];
  let nodeFound = false;
  let directParent: any | null = null;


  // Caso 1: nó alvo é raiz
  if (roots.some(r => r.email === targetEmail)) {
    return { status: "is_root", parentsArray: [] };
  }

  function findAvailableAncestor(
    node: any | null
  ): { label: string; email: string } | null {
    while (node) {
      if (node.is_available !== false) {
        return { label: node.label, email: node.email };
      }
      node = (node as any).__parent || null;
    }
    return null;
  }

  function helper(node: any, parent: any | null) {
    (node as any).__parent = parent;

    if (node.email === targetEmail) {
      nodeFound = true;
      directParent = parent;

      const validParent = findAvailableAncestor(parent);
      if (validParent) {
        parents.push(validParent);
      }
    }

    if (node.children) {
      for (const child of node.children) {
        helper(child, node);
      }
    }
  }

  for (const root of roots) {
    helper(root, null);
  }

  const uniqueParents = parents.filter(
    (p, idx, arr) => arr.findIndex(x => x.email === p.email) === idx
  );

  // decidir status final
  if (!nodeFound) {
    return { status: "node_not_found", parentsArray: [] };
  }
  if (uniqueParents.length === 0) {
    return { status: "all_parents_unavailable", parentsArray: [] };
  }

  // Caso: Nó é filho direto de root
  if (
    directParent &&
    roots.some(r => r.email === directParent.email) &&
    !roots.some(r => r.email === targetEmail)
  ) {
    return { status: "is_root_child", parentsArray: uniqueParents };
  }

  // Caso: só tem um pai e não tem avô
  if (directParent && !(directParent as any).__parent) {
    return { status: "only_one_parent", parentsArray: uniqueParents };
  }

  return { status: "ok", parentsArray: uniqueParents };
}
